import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-repair-network',
  imports: [CommonModule],
  templateUrl: './repair-network.html',
  styleUrl: './repair-network.scss'
})
export class RepairNetwork {

  ngOnInit() {
    this.clearLocalStorage();
    this.clearLocalStorageAll();
  }
   
   clearLocalStorage() {
    localStorage.removeItem('vehicleData');
    console.log('Local storage cleared');
  }
  clearLocalStorageAll() {
    localStorage.clear();
    console.log('All local storage cleared');
  }

  // <script>
  //           window.addEventListener("load", function () {
  //               checkSubmit();
  //           });

  //           function checkSubmit() {
  //               var name = document.getElementById('name').value;
  //               var mobile = document.getElementById('mobile').value;
  //               if (name && mobile) {
  //               document.getElementById('join-us-temp').style.display = 'none';
  //               document.getElementById('join-us').style.display = 'block';
  //               } else {
  //               document.getElementById('join-us').style.display = 'none';
  //               document.getElementById('join-us-temp').style.display = 'block';
  //               }
  //           }

  //           function formSubmit() {
  //               var name = document.getElementById('name').value;
  //               var mobile = document.getElementById('mobile').value;
  //               var templateType = document.getElementById('templateType').value;
  //               var email = document.getElementById('email').value;
  //               const pageLoader = document.querySelector(".page-loader");
  //               pageLoader.classList.remove("done");

  //               if (name && mobile) {
  //               var dataToSend = {
  //                   name: name,
  //                   mobile: mobile,
  //                   email: email,
  //                   templateType: templateType
  //               };

  //               fetch('./assets/php/contact.php', {
  //                   method: 'POST',
  //                   headers: {
  //                   'Content-Type': 'application/json'
  //                   },
  //                   body: JSON.stringify(dataToSend)
  //               }).then(response => response.json()).then(data => {
  //                   pageLoader.classList.add("done");
  //                   if (data.status == 200) {
  //                   document.getElementById('email-success-title').innerHTML = data.msg;
  //                   document.getElementById('email-success-subtitle').innerHTML = "We will call you shortly and explain the onboarding process.";
  //                   document.getElementById('success-email').style.display = 'block';
  //                   document.getElementById('fail-email').style.display = 'none';
  //                   } else {
  //                   document.getElementById('email-success-title').innerHTML = "Failed";
  //                   document.getElementById('email-success-subtitle').innerHTML = data.msg;
  //                   document.getElementById('success-email').style.display = 'none';
  //                   document.getElementById('fail-email').style.display = 'block';
  //                   }
  //                   var myModal = document.getElementById('modal-email');
  //                   var modal = new bootstrap.Modal(myModal);
  //                   modal.show();
  //               }).catch(error => console.error('Error:', error));
  //               } else {
  //               form.submit();
  //               }
  //           }

  //           function redirectHome() {
  //               window.location.href = "/index.html";
  //           }

  //           function filterContent() {
  //               var filter = document.getElementById('garage').value;
  //               var items = document.querySelectorAll('.Garage-list .card');
  //               items.forEach(function (item) {
  //               if (filter === 'all' || item.querySelector('.content-item').getAttribute('data-category') === filter) {
  //                   item.style.display = 'block';
  //               } else {
  //                   item.style.display = 'none';
  //               }
  //               });
  //           }

  //           function filterLocationContent() {
  //           var filter = document.getElementById('location').value;
  //           var items = document.querySelectorAll('.Garage-list .card');
  //           items.forEach(function (item) {
  //           if (filter === 'all' || item.querySelector('.content-item').getAttribute('data-location') === filter) {
  //               item.style.display = 'block';
  //           } else {
  //               item.style.display = 'none';
  //           }
  //           });
  //       }
  //       </script>

  //       <script>
  //       document.getElementById('modal-join-us').addEventListener('hidden.bs.modal', function () {
  //           document.getElementById('contact-manufacturer').reset();
  //       });
  //       </script>

  //       <script>
  //       document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  //           anchor.addEventListener('click', function (e) {
  //           e.preventDefault();
  //           document.querySelector(this.getAttribute('href')).scrollIntoView({
  //               behavior: 'smooth'
  //           });
  //           });
  //       });
  //       </script>

}
